module.exports = require('crypto').randomBytes



//////////////////
// WEBPACK FOOTER
// ./node_modules/randombytes/index.js
// module id = 423
// module chunks = 0